<template>
    <BreadCrumb PageTitle="Liste des informations du footer" />
    <ListeInfoFooter/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeInfoFooter from "../../components/InfoFooter/ListeInfoFooter.vue";

    export default defineComponent({
      name: "ListeInfoFooterPage",
      components: {
        BreadCrumb,
        ListeInfoFooter,
      },
    });
  </script>